export const mergeClasses = (classes: string[]) =>
  classes.join(" ").replace(/\s+/g, " ").trim();
